import { AlertOctagon, RefreshCw } from 'lucide-react';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { EmptyState } from '@/components/common/empty-state';
import { Button } from '@/components/ui/button';

/**
 * A crash in one screen should not take the console down. Router-level so it
 * catches render and loader failures anywhere below it.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'An unexpected error occurred.';

  return (
    <div className="mx-auto flex h-full max-w-xl items-center px-6 py-16">
      <EmptyState
        icon={AlertOctagon}
        title="This screen hit a problem"
        description={message}
        className="w-full"
        action={
          <div className="flex gap-2">
            <Button size="sm" onClick={() => navigate(0)}>
              <RefreshCw className="size-3.5" /> Reload
            </Button>
            <Button size="sm" variant="secondary" onClick={() => navigate('/map')}>
              Back to the map
            </Button>
          </div>
        }
      />
    </div>
  );
}
